module.exports = __webpack_public_path__ + "static/media/emma_vp_timeline_2.bde082b8.jpg";